<div class="design-step-content">
  <div class="toolbar-wrapper">
    @if (!previewKind || isLargeDevice()) {
      <div class="toolbar">
        @if (isStaticToolboxAvailable('LayoutToolbox')) {
          <div class="toolbox"
               [class]="designStepToolbox === 'LayoutToolbox' ? 'active' : ''">
            <div class="toolbox-button"
                 (click)="toolboxToggle('LayoutToolbox')">
              <mat-icon svgIcon="designs"></mat-icon>
              {{ 'i18n.button.design' | translate }}
            </div>
          </div>
        }
        @if (isStaticToolboxAvailable('LayoutToolbox') &&
             isStaticToolboxAvailable('GalleryToolbox')) {
          <div class="divider"></div>
        }
        @if (isStaticToolboxAvailable('GalleryToolbox')) {
          <div class="toolbox"
               [class]="designStepToolbox === 'GalleryToolbox' ? 'active' : ''">
            <div class="toolbox-button"
                 (click)="photosButtonClicked()">
              <mat-icon svgIcon="photos"></mat-icon>
              {{ 'i18n.button.photos' | translate }}
            </div>

            @if (showImagePromoter) {
              <div class="promoter image-promoter" #imagePromoter>
                <div class="promoter-title">
                  {{ 'i18n.imagePromoter.title' | translate }}
                </div>
                <div class="promoter-content">
                  {{ 'i18n.imagePromoter.content' | translate }}
                </div>
              </div>
            }
          </div>
        }
        @if (isStaticToolboxAvailable('GalleryToolbox') &&
             isStaticToolboxAvailable('TextEditToolbox')) {
          <div class="divider"></div>
        }
        @if (isStaticToolboxAvailable('LayoutToolbox') &&
             isStaticToolboxAvailable('TextEditToolbox') &&
             !isStaticToolboxAvailable('GalleryToolbox')) {
          <div class="divider"></div>
        }
        @if (isStaticToolboxAvailable('TextEditToolbox')) {
          <div class="toolbox"
               [class]="designStepToolbox === 'TextEditToolbox' ? 'active' : ''">
            <div class="toolbox-button"
                 (click)="toolboxToggle('TextEditToolbox')">
              <mat-icon svgIcon="text"></mat-icon>
              {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
            </div>
          </div>
        }
      </div>
    }

    @if (previewKind && !isLargeDevice()) {
      <div class="toolbar-mini">
        @if (isStaticToolboxAvailable('LayoutToolbox')) {
          <div class="toolbar-mini-row">
            <span class="toolbar-mini-title">
              {{ 'i18n.button.design' | translate }}
            </span>
            <span class="toolbar-mini-label">
              {{ templateTitle }}
            </span>
            <span class="toolbar-mini-edit">
              <mat-icon (click)="toolboxToggle('LayoutToolbox')"
                        svgIcon="text-edit"></mat-icon>
            </span>
          </div>
        }
        @if (isStaticToolboxAvailable('LayoutToolbox') &&
             isStaticToolboxAvailable('TextEditToolbox')) {
          <div class="divider"></div>
        }
        @if (isStaticToolboxAvailable('TextEditToolbox')) {
          <div class="toolbar-mini-row">
            <span class="toolbar-mini-title">
              {{ 'i18n.button.mobile.createNewTextPlaceholders' | translate }}
            </span>
            @if (customTextPlaceholder; as customText) {
              <span class="toolbar-mini-label"
                    [style.font-family]="customText.getFontFamily()">
                {{ customText.getPlaintext() }}
              </span>
            }
            @else {
              <span class="toolbar-mini-label add-custom-text">
                {{ 'i18n.designStep.addCustomText' | translate }}
              </span>
            }
            <span class="toolbar-mini-edit">
              <mat-icon (click)="toolboxToggle('TextEditToolbox')"
                        svgIcon="text-edit"></mat-icon>
            </span>
          </div>
        }
      </div>
    }
  </div>

  @if (designStepToolbox || placeholderToolbox === 'TextToolbox') {
    <div class="dim-background"></div>
  }

  <div class="toolbox-area"
       [class.open]="designStepToolbox || placeholderToolbox === 'TextToolbox'"
       [class.no-transition]="isToolboxTransitionSuppressed">
    <div class="toolbox-wrapper"
         [class.open]="designStepToolbox === 'LayoutToolbox'">
      <layout-toolbox></layout-toolbox>
    </div>
    <div class="toolbox-wrapper"
         [class.open]="designStepToolbox === 'GalleryToolbox'">
      <gallery-toolbox></gallery-toolbox>
    </div>
    <div class="toolbox-wrapper"
         [class.open]="designStepToolbox === 'TextEditToolbox'">
      <text-edit-toolbox></text-edit-toolbox>
    </div>
    <div class="toolbox-wrapper"
         [class.open]="designStepToolbox === 'ImageToolbox'">
      <image-toolbox></image-toolbox>
    </div>

    <div class="toolbox-wrapper"
         [class.open]="placeholderToolbox === 'TextToolbox'">
      <text-toolbox></text-toolbox>
    </div>
  </div>

  <div id="design-area" [class.preview-active]="isPreviewActive">
    @if (isPreviewActive && boxPromoterContentKey) {
      <div class="promoter box-promoter">
        <div class="promoter-title">
          {{ boxPromoterTitleKey | translate }}
        </div>
        <div class="promoter-content">
          {{ boxPromoterContentKey | translate }}
        </div>
      </div>
    }
    <div class="canvas-area">
      @switch (previewKind) {
        @case (PreviewKind.webgl) {
          <webgl-preview class="preview"
                         [attr.aria-hidden]="!isPreviewActive"
                         (previewFailed)="respondToPreviewFailure(PreviewKind.webgl)">
          </webgl-preview>
        }
        @case (PreviewKind.prngl) {
          <prngl-preview class="preview"
                         [attr.aria-hidden]="!isPreviewActive"
                         (previewFailed)="respondToPreviewFailure(PreviewKind.prngl)">
          </prngl-preview>
        }
      }
      <stage [attr.aria-hidden]="isPreviewActive"></stage>
    </div>
  </div>
  <input imageUpload #imageSelect id="image-select"
    type="file" multiple accept="image/*"/>
</div>
